export const siteSettings = {
  name: "Reo Capital",
  link: "https://reocapitals.com",
  email: "support@reocapitals.com",
  appLink: "https://app.reocapitals.com",
};
